import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
export default function ProtectedRoute({ allowedRoles }) {
  const { session, role, loading, profile } = useAuth()
  const isDemoMode = profile?.demo_mode
  if (loading) return <div style={{padding:'40px',color:'#6B7D6B'}}>Loading...</div>
  if (!session && !isDemoMode) return <Navigate to="/login" replace />
  if (allowedRoles && !allowedRoles.includes(role)) return <Navigate to="/dashboard" replace />
  return <Outlet />
}
